import React, { useEffect, useState, useRef, useCallback } from 'react';

// import {
//   Grid, 
// } from "@mui/material";

import { 
  Character,
  CharacterFeature,
  CharacterEldritchInvocation,
  EldritchInvocation,
  CharacterSpell,
  CharacterItem,
  SummonOption2,
  PseudoItem,
} from "@dndModels";
import { ModelBase } from "@models";

import DandDAPI from "@utilities/smart_api";
// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

// import CharacterEldritchInvocationBox from './CharacterEldritchInvocationBox';
import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
}

const api = DandDAPI.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterEldritchInvocationsBox({
  character,
  obj,
  onChange,
}: Props) {
  const fos = obj.feature_options as CharacterEldritchInvocation[];
  const [selected, setSelected] = useState(fos.filter(o => o.source_id !== "").map(o => o.source_id));
  const [changing, setChanging] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [eldritch_invocations, setEldritchInvocations] = useState<EldritchInvocation[]>([]);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      data_util.getEldritchInvocations().then(res => {
        setEldritchInvocations(res);
        setLoading(false);
      });
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    }
  }, [character, fetched, setFetched, mounted, recalculated, setLoading, setEldritchInvocations]);
  
  const change = useCallback(async () => {
    // debugger;
    const new_obj = obj;
    const new_fos = new_obj.feature_options as CharacterEldritchInvocation[];
    const checked: string[] = [];
    const added: string[] = []; //  changed.filter(o => new_fos.filter(o2 => o2.source_id === o).length === 0);
    for (let i = 0; i < selected.length; ++i) {
      const ei_id = selected[i];
      const old_fo = new_fos.find(o => o.source_id === ei_id && !checked.includes(o.true_id));
      if (old_fo) {
        checked.push(old_fo.true_id);
      } else {
        added.push(ei_id);
      }
    }
    const removed = new_fos.filter(o => !checked.includes(o.true_id));
    if (removed.length > 0) {
      for (const char_ei of removed) {
        if (char_ei.source) {
          // console.log(char_ei);
          for (const char_item of character.inventory.items) {
            // console.log(char_item);
            char_item.char_feature_bases = char_item.char_feature_bases.filter(o => 
              o.ancestries.filter(o2 => o2.true_id === char_ei.true_id).length === 0);
            for (const scfs of char_item.sub_char_feature_sources) {
              scfs.char_feature_bases = scfs.char_feature_bases.filter(o => 
                o.ancestries.filter(o2 => o2.true_id === char_ei.true_id).length === 0);
            }
          }
          char_util.removeCharFeatureBasesFor(character, char_ei);
          char_ei.char_feature_bases = [];
          char_ei.source_id = "";
          char_ei.source_name = "";
          char_ei.source_type = "";
          char_ei.source = null;
        }
      }
      onChange(new_obj);
    } 
    if (added.length > 0) {
      for (const id of added) {
        // Get an empty char_ei and set the selected_ei to it
        const char_ei = new_fos.find(o => o.source_id === "");
        const selected_ei = eldritch_invocations.find(o => o._id === id);
        if (char_ei && selected_ei) {
          await api.loadObject(selected_ei);
          await char_ei.copy_source({ char: character, feature_source: selected_ei, parent_cf: obj });
        }
      }
      onChange(new_obj);
    }
  }, [character, eldritch_invocations, obj, onChange, selected]);

  useEffect(() => {
    if (changing) {
      setChanging(false);
      change();
    }
  }, [changing, setChanging, change]);


  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <>
        <CharacterListOptionsInput
          data_type="eldritch_invocation"
          char={character}
          choose_max={fos.length} 
          selected={selected} 
          selected_elsewhere={
            character.mind.eldritch_invocations.filter(o => 
              // o.ancestries.filter(o2 => o2.source_id !== "" && obj.true_id !== o2.true_id).length > 0
              fos.filter(o2 => o2.true_id === o.true_id).length === 0
            ).map(o => o.source_id)
          }
          onChange={(changed: string[]) => {
            setSelected(changed);
            setChanging(true);
          }} 
          getDisabledReasons={(obj) => {
            if (obj instanceof EldritchInvocation) {
              // if (obj.name.includes("Thirsting")) {
              //   console.log(obj);
              // }
              const reasons = char_util.fitLimits(character, obj.limitations, "eldritch_invocation", obj._id); // , obj.name.includes("Thirsting"));
              return reasons === "true" ? "" : reasons;
            }
            return "";
          }}
        />
      </>
    );
  }
}
